import type { AppDefinition } from '../../types/apps';

export const AutomationsAppDefinition: AppDefinition = {
  appId: 'automations',
  name: 'Automations',
  version: '1.0.0',
  description: 'Create scheduled agents and automation workflows that run in the background.',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'Lightning',
    phosphorWeight: 'duotone',
    color: '#f97316',
  },
  component: 'AutomationsApp',
  entityTypes: ['Automation'],
  requiresProps: false,
  requiresEntity: false,
  isCore: true,
};
